import {
  DefaultEntity,
  SequencingTypeEntity,
  SequencingTypeParams,
} from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class SequencingTypeService extends BaseService<
  'sequencingType',
  SequencingTypeEntity,
  DefaultEntity
> {
  constructor() {
    super('sequencing-types');
  }

  getAllSequencingTypes = (
    params?: SequencingTypeParams,
  ): Promise<SequencingTypeEntity[]> => {
    return APIService.get(this.path + '/all', { params });
  };
}
export const sequencingTypeService = new SequencingTypeService();
